// Criterio único de "trámite activo" a partir del nombre de su estado actual. Mismo criterio que
// usan los formularios de ART/RTI para detectar duplicados: sin estado informado se asume activo.
// Lo comparten la ficha de atención y los chips del listado de clientes.
const TOKENS_ESTADO_CERRADO = ['finaliz', 'cancel', 'rechaz', 'cerrad', 'baja'];

/**
 * @param {{nombreEstadoActual?: string, estadoActual?: string}} tramite
 * @returns {boolean}
 */
export function esTramiteActivo(tramite) {
    const estado = String(tramite?.nombreEstadoActual || tramite?.estadoActual || '').toLowerCase();
    if (!estado) return true;
    return !TOKENS_ESTADO_CERRADO.some((token) => estado.includes(token));
}

export default esTramiteActivo;
